/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type TestimonialTypeEnum = (typeof TestimonialTypeEnum)[keyof typeof TestimonialTypeEnum];

export const TestimonialTypeEnum = {
  testimonial: 'testimonial',
} as const;
